<template>
  <div id="sign-in-card" class="uk-position-center">
    <div class="uk-card">
      <div class="uk-card-body">
        <div @click="close"
             @mouseleave="resolveHover(false)"
             @mouseover="resolveHover(true)"
             class="uk-position-top-right add-pointer
              close-icon">
          <img :src=closeIcon
               v-if="!hover">
          <img :src=hoverIcon
               v-else>
        </div>
        <div class="uk-flex card-element">
          <div class="uk-width-1-4">
            <div class="uk-flex">
              <img :src="SignInIcon" class="card-icon"/>
            </div>
          </div>
          <div class="uk-width-3-4">
            <h2 class="uk-card-title"> {{$t('legacyCards.legacySignInShare.share.title')}}</h2>

            <p>{{$t('legacyCards.legacySignInShare.share.body')}}</p>
            <div class="uk-flex sign-up-button">
              <button @click="login" class="uk-button cp-primary-button">
                {{$t('general.signIn')}}
              </button>
            </div>
          </div>
        </div>
        <hr/>
        <div class="uk-flex card-element">
          <div class="uk-width-1-4">
            <div class="uk-flex">
              <img :src="SearchSectionIcon" class="card-icon"/>
            </div>
          </div>
          <div class="uk-width-3-4">
            <h2 class="uk-card-title"> {{$t('legacyCards.legacySignInShare.search.title')}}</h2>

            <p>{{$t('legacyCards.legacySignInShare.search.body')}}</p>
            <div class="uk-flex sign-up-button">
              <button @click="search" class="uk-button cp-primary-button search">
                {{$t('general.search')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import iconUtil from '../../../utils/icon-util'
  import * as misc from '../../../enums/misc'
  import {LEGACY_SMEX_SEARCH, LEGACY_EXCHANGE_DOMAIN} from '../../../enums/static-urls'
  import {HOME} from '../../../enums/routes'

  export default {
    name: 'legacy-sign-in-card',
    data() {
      return {
        closeIcon: iconUtil.resolve(misc.CANCEL_BLACK),
        hoverIcon: iconUtil.resolve(misc.CANCEL_HOVER),
        SignInIcon: iconUtil.resolve(misc.CLOUD_ICON_SIGN_IN_MODAL),
        SearchSectionIcon: iconUtil.resolve(misc.SEARCH_ICON_SIGN_IN_MODAL),
        hover: false
      }
    },
    methods: {
      resolveHover(hover) {
        this.hover = hover
      },
      login() {
        let state = {
          from: HOME,
          download: false
        }
        this.$auth.id.signIn(state)
      },
      search() {
        window.location = LEGACY_SMEX_SEARCH
      },
      close() {
        window.location = LEGACY_EXCHANGE_DOMAIN
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../styles/breakpoints';
  @import '../../../styles/colours';

  #sign-in-card{
    z-index: 3;
  }

  .uk-width-3-4 {
    margin-left: 10px;
  }

  .card-element {
    padding: 36px 0 36px 15px;
    margin-right: 35px;
  }

  .uk-card-body {
    padding: 0px;
  }

  .uk-card {
    background-color: $app-background;
    width: 908px;
    min-height: 549px;

    p {
      font-size: 18px;
      line-height: 1.11;
      color: $content-text;
      overflow-wrap: break-word;
    }

    .card-icon {
      margin-top: 10px;
      margin-left: 25px;
      width: 153px;
    }

    .link {
      color: $content-link-blue;
      font-weight: bold;
      font-size: 18px;
    }

    .cp-primary-button {
      width: 254px;
      height: 44px;
      text-transform: none;
      font-size: 20px;
      font-weight: bold;
    }
  }

  .sign-up-button {
    padding-top: 25px;
  }

  .uk-card-title {
    font-size: 24px;
    font-weight: bold;
    line-height: 1.29;
    color: $content-text;
    margin-top: 0px;
    padding-bottom: 25px;
  }

  .search::first-letter {
    text-transform: capitalize;
  }

  hr {
    width: 100%;
    padding: 0;
    margin: 0;
  }

  @media screen and (max-width: $breakpoint-medium) {
    .card-element {
      padding: 30px 0 30px 15px;
      margin-right: 15px;
    }

    .uk-card-title {
      font-size: 18px;
    }

    .uk-card {
      width: 550px;
      min-height: 549px;

      .card-icon {
        margin-top: 10px;
        margin-left: 5px;
      }

      p {
        font-size: 16px;
      }

      .link {
        font-size: 16px;
      }
    }
  }

  @media screen and (max-width: $breakpoint-small) {
    .card-element {
      padding: 15px 0 15px 15px;
      margin-right: 15px;
    }
    .uk-card {
      width: 400px;
      min-height: 549px;
      padding-left: 5px;
      padding-right: 5px;
    }
  }

  @media screen and (max-width: 400px) {
    .card-element {
      padding: 15px 0 15px 15px;
      margin-right: 15px;
    }
    .uk-card {
      width: 325px;
      min-height: 549px;
      padding-left: 5px;
      padding-right: 5px;
    }
  }
</style>
